import React from 'react'
import { MenuContainer } from '../../components/menuContainer/MenuContainer'
import styled from 'styled-components'
import { Container } from 'react-bootstrap'
import { motion } from 'framer-motion'

const Image = styled.img`
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  background-color: var(--bs-skyblue);
  padding: 16px 19px;
  @media (max-width: 991px) {
    width: 350px;
    height: auto;
    padding: 13px 16px;
  }
  @media (max-width: 767px) {
    width: 439px;
    padding: 16px 19px;
  }
  @media (max-width: 575px) {
    width: 380px;
  }
  @media (max-width: 430px) {
    width: 300px;
  }
`

const ImageMid = styled(Image)`
  margin: 30px 0;
  @media (max-width: 767px) {
    margin: 30px auto;
  }
`

const Left = styled.div`
  position: relative;
`

const Right = styled.div`
  position: relative;
  top: 10rem;
  margin-bottom: 10rem;
  @media (max-width: 767px) {
    top: 30px;
  }
`

export const License = () => (
  <MenuContainer title="회사소개" menu="면허보유현황" pointRadius="50%">
    <Container
      className="d-md-flex justify-content-center"
      style={{ gap: '23px' }}
    >
      <Left>
        <motion.div
          layout="size"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          <Image src="/license/license1.png" alt="license" />
        </motion.div>
        <motion.div
          layout="size"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          <ImageMid src="/license/license2.png" alt="license" />
        </motion.div>
        <motion.div
          layout="size"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          <Image src="/license/license3.png" alt="license" />
        </motion.div>
      </Left>
      <Right>
        <motion.div
          layout="size"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          <Image src="/license/license4.png" alt="license" />
        </motion.div>
        <motion.div
          layout="size"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          <ImageMid src="/license/license5.png" alt="license" />
        </motion.div>
        <motion.div
          layout="size"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          <Image src="/license/license6.png" alt="license" />
        </motion.div>
      </Right>
    </Container>
  </MenuContainer>
)
